import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { RegulamentoComponent } from '../regulamento/regulamento.component';
import { SefSaldoFinanciamentoComponent } from '../sef/sef-saldo-financiamento/sef-saldo-financiamento.component';

const financeiroRoutes = [
    { path: 'sefSaldo', component: SefSaldoFinanciamentoComponent },
    { path: 'regulamento/pbb', component: RegulamentoComponent },
    { path: 'regulamento/pbdc', component: RegulamentoComponent },
    { path: 'regulamento/pcd', component: RegulamentoComponent },
]

@NgModule({
    imports: [RouterModule.forChild(financeiroRoutes)],
    exports: [RouterModule]
})
export class FinanceiroRoutingModule {
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/financeiro/router/financeiro.router.ts